import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { ITaxInvoiceJournalTransactionRecordDto } from "../../../dtos/transactions/ITaxInvoiceJournalTransactionRecordDto";

interface IProps {
  items: ITaxInvoiceJournalTransactionRecordDto[];
}

export const TaxInvoiceJournalTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="documentNumber" dataType={"string"} caption="Document Number" />
          <Column width={150} dataField="operationCode" dataType={"string"} caption="Operation Code" />
          <Column width={150} dataField="registerDate" dataType={"datetime"} caption="Register Date" />
          <Column width={150} dataField="companyId" dataType={"string"} caption="Company Id" />
          <Column width={150} dataField="companyName" dataType={"string"} caption="Company Name" />
          <Column width={150} dataField="customerId" dataType={"string"} caption="Customer Id" />
          <Column width={150} dataField="customerName" dataType={"string"} caption="Customer Name" />
          <Column width={150} dataField="currencyId" dataType={"string"} caption="Currency Id" />
          <Column width={150} dataField="currencyName" dataType={"string"} caption="Currency Name" />
          <Column width={150} dataField="amount" dataType={"number"} caption="Amount" />
          <Column width={150} dataField="amountVat" dataType={"number"} caption="Amount Vat" />
          <Column width={150} dataField="tin" dataType={"string"} caption="Tin" />

          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
